// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_vn";
export var lbContainerInner = "B_vp";
export var movingForwards = "B_vq";
export var movingForwardsOther = "B_vr";
export var movingBackwards = "B_vs";
export var movingBackwardsOther = "B_vt";
export var lbImage = "B_vv";
export var lbOtherImage = "B_vw";
export var prevButton = "B_vx";
export var nextButton = "B_vy";
export var closing = "B_vz";
export var appear = "B_vB";